import React from 'react';
import {getServerTexts} from '../texts';
import {PersonalizationSearchesDialog} from './PersonalizationSearchesDialog';

export const personalizationSearchesDialogRef: React.RefObject<any> = React.createRef();

export async function renderPersonalizationSearchesDialog(root) {
    await getServerTexts();

    root.render(<PersonalizationSearchesDialog ref={personalizationSearchesDialogRef} />);

    return personalizationSearchesDialogRef;
}
